import { useEffect, useState } from "react";
import { isHighReturner } from "../utils/isHighReturner";

export const useHighReturner = (appConfig) => {
  const [state, setState] = useState({ highReturner: false, checking: true });

  useEffect(() => {
    let active = true;
    setState({ highReturner: false, checking: true });
    isHighReturner(appConfig)
      .then((result) => {
        if (active) {
          setState({ highReturner: result, checking: false });
        }
      })
      .catch(() => {
        // Fail open: an SDK failure must not leave a stale or locked state.
        if (active) {
          setState({ highReturner: false, checking: false });
        }
      });
    return () => {
      active = false;
    };
  }, [appConfig]);

  return state;
};
